import { Component, OnInit, Input } from '@angular/core';
import { ConfigCard, GetPersonalBlackList, PersonalBlackList, SecurityReference } from 'src/app/core/interfaces/interfaces';
import { environment } from 'src/environments/environment';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { PersonalModel } from '../../../models/Personal/personalModel';
import { PersonalEmployerInfo } from '../../../models/Personal/personalEmployerInfo';
import { CommonOptions, City, DaneCity, SecurityReferences, Back } from '../../../interfaces/interfaces';
import { NumberCountry } from '../../../constants/number-city.constant';
import { CommonService } from '../../../services/modules/common.service';
import { DialogService } from '../../../services/utils/dialog.service';
import { ContratingService } from '../../../services/modules/contrating.service';
import { IndividualContractId, IndividualContractPut } from '../../../models/IndividualContract/individualContractId';
import { FechasService } from '../../../services/utils/fechas.service';
import { SnackBarService } from '../../../services/utils/snackBar.service';
import { DocumentI, DocumentIndividualPost, getDocumentIndividualContract } from '../../../models/IndividualContract/document';
import { Positions } from '../../../models/IndividualContract/interfacesIndividualContract';
import { TypeSecurityReference } from 'src/app/core/constants/type-security-references';
import { CurrencyPipe } from '@angular/common';
import { PersonalService } from 'src/app/core/services/modules/personal.service';
import { CommonMetodService } from 'src/app/core/services/utils/commonMetod.service';
import { EmployerService } from 'src/app/core/services/modules/employer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'cards-contracting',
  templateUrl: './cards-contracting.component.html',
  styleUrls: ['./cards-contracting.component.scss']
})
export class CardsContractingComponent implements OnInit {

  @Input() set _configCard(value: ConfigCard) {
    this.configCard = value;
    if (value.typeCard === 'contract_proyects') {
    }
  }

  @Input() set _individualContractId(value: string) {
    if (value) {
      this.IDindividualContract = value;
      this.getContracting(value);
    }
  }

  @Input() set _permissions(value: string[]) {
    if (value.length > 0) {
      this.permissions = value;
    }
  }

  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private commonMetodService: CommonMetodService,
    private dialogService: DialogService,
    private contratingService: ContratingService,
    private fechasService: FechasService,
    private snackBService: SnackBarService,
    private currencyPipe: CurrencyPipe,
    private personaService: PersonalService,
    private employerService: EmployerService,
    private router: Router
  ) {
    this.s3Bucket = environment.api.s3Bucket;

    this.formPersonal = this.fb.group({
      Nationality: new FormControl('', Validators.required),
      DocumentNumber: new FormControl(''),
      DocumentType: new FormControl(''),
      Name: new FormControl('', Validators.required),
      LastName: new FormControl('', Validators.required),
      BirthDate: new FormControl('', Validators.required),
      Sex: new FormControl('', Validators.required),
      RH: new FormControl('', Validators.required),
      contryNalcionality: new FormControl('', Validators.required),
      CityCode: new FormControl('', Validators.required),
      CityOfBirthCode: new FormControl('', Validators.required),
      EmergencyContact: new FormControl(''),
      EmergencyPhone: new FormControl(''),
      Address: new FormControl('', Validators.required),
      PhoneNumber: new FormControl('', Validators.required),
      TownCode: new FormControl('', Validators.required),
      Email: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      Photo: '',
      EpsId: '',
      AfpId: ''
    });
    this.formCetificados = this.fb.group({
      EpsId: new FormControl('', Validators.required),
      AfpId: new FormControl('', Validators.required),
    });
    this.formContractNumber = this.fb.group({
      ContractNumber: ''
    });
    this.formDatosContrato = this.fb.group({
      IndividualContractTypeId: new FormControl('', Validators.required),
      PersonalEmployerInfoId: new FormControl('', Validators.required),
      PositionId: new FormControl('', Validators.required),
      Salary: ['', Validators.min(1)],
      PayPeriodId: new FormControl('', Validators.required),
      StartDate: new FormControl('', Validators.required),
      // EndDate: new FormControl('',Validators.required),
      contry: new FormControl('0', Validators.required),
      ProjectId: new FormControl('', Validators.required),
      ContractCityId: new FormControl('', Validators.required),
      ContractId: '',
      examType: ''
    });

    this.formExamType = this.fb.group({
      examType: new FormControl('', Validators.required)
    });

    this.formDatosContrato.valueChanges.subscribe(form => {
      if (form.Salary && this.commonMetodService._validarDateMoney(form.Salary)
        ) {
        this.formDatosContrato.patchValue({
          Salary: this.currencyPipe.transform(form.Salary.toString().replace(/\D/g, '').replace(/^0+/,
            ''), 'USD', 'symbol', '1.0-0').replace(/,/gi, '.')
        }, {emitEvent: false});
      }
    });

    this.formOtrosDatos = this.fb.group({
      BankAccount: new FormControl('', Validators.required),
      CcfId: new FormControl('', Validators.required),
      BankId: new FormControl('', Validators.required),
      BankAccountTypeId: new FormControl('', Validators.required),
      ContributorTypeId: new FormControl('', Validators.required),
      TypeARLId: new FormControl('', Validators.required)
    });
  }
  configCard: ConfigCard;
  indexSelect = 0;
  formDataPhoto: FormData;
  production = environment;
  individualContract: IndividualContractId;
  individualContractPut: IndividualContractPut;

  employer: any;
  s3Bucket: string;
  state = '';
  flagListF = true;
  IDindividualContract: string;

  formPersonal: FormGroup;
  formExamType: FormGroup;
  personal: PersonalModel;
  formOtrosDatos: FormGroup;
  formCetificados: FormGroup;
  formDatosContrato: FormGroup;
  formContractNumber: FormGroup;

  town: any[] = [];
  bancks: Back[] = [];
  rh: CommonOptions[] = [];
  sex: CommonOptions[] = [];
  proyectSelect: any[] = [];
  daneCity: DaneCity[] = [];
  permissions: string[] = [];
  positions: Positions[] = [];
  contributorType: any[] = [];
  securityReferences: any = [];
  states: CommonOptions[] = [];
  afp: SecurityReference[] = [];
  eps: SecurityReference[] = [];
  citiesNacimiento: City[] = [];
  countrys: CommonOptions[] = [];
  examType: CommonOptions[] = [];
  ips: SecurityReferences[] = [];
  CajadeCompensacion: any[] = [];
  nationality: CommonOptions[] = [];
  payPeriodType: CommonOptions[] = [];
  bankAccountType: CommonOptions[] = [];
  medicalExamType: CommonOptions[] = [];
  occupationalRisk: CommonOptions[] = [];
  docsUpload: DocumentIndividualPost[] = [];
  companyDocumentType: CommonOptions[] = [];
  documentsExamFormParameters: DocumentI[] = [];
  documentsGenerateParameters: DocumentI[] = [];
  individualContractsType: CommonOptions[] = [];
  docsUploadExam: DocumentIndividualPost[] = [];
  docsSave: getDocumentIndividualContract[] = [];
  docsUploadIniado: DocumentIndividualPost[] = [];
  dateRequiredDate: DocumentIndividualPost[] = [];
  documentsAndRquisitosParameters: DocumentI[] = [];
  dateRequiredDateExam: DocumentIndividualPost[] = [];
  docsUploadIniadoExam: DocumentIndividualPost[] = [];

  isCreateAppPersonal = false;

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
  }

  getContracting(individualContractId) {
    this.contratingService.getIndividualContractId(individualContractId).subscribe((IndividualContract: IndividualContractId) => {
      this.individualContract = IndividualContract;
      this.contratingService.getPersonalId(this.individualContract.personalemployerinfo.PersonalId).subscribe((person: PersonalModel) => {
        this.personal = person;
        this.dataFormPerson(this.individualContract, this.personal);
        this.dataFormIndividualContract(this.individualContract);
        this.state = this.individualContract.IndividualContractStage.Description;
        this.docsSave = [];
        this.docsUploadIniado = [];
        this.docsUploadIniadoExam = [];
        this.getRolStateContrating(this.state);
      });
    });
  }

  getRolStateContrating(state: string){
    switch (state) {
      case 'INICIADO':
        this.iniciado();
        break;
      case 'SOLICITADO':
        this.solicitado();
        break;
      case 'APROBADO':
        this.aprobado();
        break;
      case 'RECHAZADO':
        this.rechazado();
        break;
      case 'CONTRATADO':
        this.contratado();
        break;
      default:
        break;
    }
  }

  iniciado() {
    this.contratingService.getDocuemntsIndividualContract(this.IDindividualContract).subscribe(
      (documentsIndividualContract: getDocumentIndividualContract[]) => {
    this.documentsAndRquisitosParameters.forEach((documentParameter: DocumentI) => {
      this.docsSave = documentsIndividualContract;
      const doc = documentsIndividualContract.find(documentoId => documentoId.IdDocument === documentParameter.Id);
      if (doc !== undefined) {
          this.docsUploadIniado.push({IdDocument: documentParameter.Id, IndividualContractId: this.IDindividualContract, urlDoc: doc.File,
            Id: doc.Id, IsByDate: doc.Document.IsByDate, RequiredDate: doc.RequiredDate === '0001-01-01T00:00:00' ? '' : doc.RequiredDate});
      }
      });
    });
  }

  rechazado() {
    this.contratingService.getDocuemntsIndividualContract(this.IDindividualContract).subscribe(
      (documentsIndividualContract: getDocumentIndividualContract[]) => {
      this.documentsAndRquisitosParameters.forEach((documentParameter: DocumentI) => {
        this.docsSave = documentsIndividualContract;
        const doc = documentsIndividualContract.find(documentoId => documentoId.IdDocument === documentParameter.Id);
        if (doc !== undefined) {
          this.docsUploadIniado.push({IdDocument: documentParameter.Id, IndividualContractId: this.IDindividualContract, urlDoc: doc.File,
            Id: doc.Id, IsByDate: doc.Document.IsByDate, RequiredDate: doc.RequiredDate === '0001-01-01T00:00:00' ? '' : doc.RequiredDate});
        }
      });
    });
  }

  getDocumentStatesAll(){
    this.contratingService.getDocuemntsIndividualContract(this.IDindividualContract).subscribe(
      (documentsIndividualContract: getDocumentIndividualContract[]) => {
      this.documentsAndRquisitosParameters.forEach((documentParameter: DocumentI) => {
        this.docsSave = documentsIndividualContract;
        const doc = documentsIndividualContract.find(documentoId => documentoId.IdDocument === documentParameter.Id);
        if (doc !== undefined) {
          this.docsUploadIniado.push({IdDocument: documentParameter.Id, IndividualContractId: this.IDindividualContract, urlDoc: doc.File,
            Id: doc.Id, IsByDate: doc.Document.IsByDate, RequiredDate: doc.RequiredDate === '0001-01-01T00:00:00' ? '' : doc.RequiredDate});
        }
      });
    });
  }

  solicitado(){
    this.contratingService.getDocuemntsIndividualContract(this.IDindividualContract).subscribe(
      (documentsIndividualContract: getDocumentIndividualContract[]) => {
      this.documentsAndRquisitosParameters.forEach((documentParameter: DocumentI) => {
        this.docsSave = documentsIndividualContract;
        const doc = documentsIndividualContract.find(documentoId => documentoId.IdDocument === documentParameter.Id);
        if (doc !== undefined) {
          this.docsUploadIniado.push({IdDocument: documentParameter.Id, IndividualContractId: this.IDindividualContract, urlDoc: doc.File,
            Id: doc.Id, IsByDate: doc.Document.IsByDate, RequiredDate: doc.RequiredDate === '0001-01-01T00:00:00' ? '' : doc.RequiredDate});
        }
      });
    });
  }

  aprobado(){
    this.contratingService.getDocuemntsIndividualContract(this.IDindividualContract).subscribe(
      (documentsIndividualContract: getDocumentIndividualContract[]) => {
      this.documentsAndRquisitosParameters.forEach((documentParameter: DocumentI) => {
        this.docsSave = documentsIndividualContract;
        const doc = documentsIndividualContract.find(documentoId => documentoId.IdDocument === documentParameter.Id);
        if (doc !== undefined) {
          this.docsUploadIniado.push({IdDocument: documentParameter.Id, IndividualContractId: this.IDindividualContract, urlDoc: doc.File,
            Id: doc.Id, IsByDate: doc.Document.IsByDate, RequiredDate: doc.RequiredDate === '0001-01-01T00:00:00' ? '' : doc.RequiredDate});
        }
      });
    });
    this.contratingService.getDocuemntsIndividualContract(this.IDindividualContract).subscribe(
      (documentsIndividualContract: getDocumentIndividualContract[]) => {
      this.documentsExamFormParameters.forEach((documentParameter: DocumentI) => {
        const doc = documentsIndividualContract.find(documentoId => documentoId.IdDocument === documentParameter.Id);
        if (doc !== undefined) {
          this.docsUploadIniadoExam.push({IdDocument: documentParameter.Id, IndividualContractId: this.IDindividualContract,
            urlDoc: doc.File, Id: doc.Id, IsByDate: doc.Document.IsByDate, DocumentContents: doc.Document.DocumentContents,
            RequiredDate: doc.RequiredDate === '0001-01-01T00:00:00' ? '' : doc.RequiredDate});
        }
        const docExamenMedico = documentsIndividualContract.find(docIndi => docIndi.Document.DocumentContents === 'SOLICITUD_DE_EXAMENES_MEDICOS');
        if (docExamenMedico !== undefined) {
          this.formExamType.get('examType').setValue(docExamenMedico.MedicalExamTypeId !== null &&
          docExamenMedico.MedicalExamTypeId !== 0 ? docExamenMedico.MedicalExamTypeId = docExamenMedico.MedicalExamTypeId : '');
        }
      });
    });
    this.employerService.getAddCCFemployerId(this.individualContract.personalemployerinfo.Employer.Id).subscribe((CCFemployer: any[]) => {
      this.CajadeCompensacion = CCFemployer;
    });
    this.commonService.getTypeSecurityReferences(4).subscribe(rest => {
      this.ips = rest;
    });
    this.contratingService.getBanks().subscribe((rest: any) => {
      this.bancks = rest;
    });
    this.commonService.getCommonOptions('MedicalExamType').subscribe(rest => {
      this.medicalExamType = rest;
    });
    this.commonService.getCommonOptions('BankAccountType').subscribe(rest => {
      this.bankAccountType = rest;
    });
    this.commonService.getCommonOptions('OccupationalRisk').subscribe(rest => {
      this.occupationalRisk = rest;
    });
    this.contratingService.getContributorType().subscribe((rest: any) => {
      this.contributorType = rest;
    });
  }

  contratado(){
    this.contratingService.getDocuemntsIndividualContract(this.IDindividualContract).subscribe(
      (documentsIndividualContract: getDocumentIndividualContract[]) => {
      this.documentsAndRquisitosParameters.forEach((documentParameter: DocumentI) => {
        this.docsSave = documentsIndividualContract;
        const doc = documentsIndividualContract.find(documentoId => documentoId.IdDocument === documentParameter.Id);
        if (doc !== undefined) {
          this.docsUploadIniado.push({IdDocument: documentParameter.Id, IndividualContractId: this.IDindividualContract, urlDoc: doc.File,
            Id: doc.Id, IsByDate: doc.Document.IsByDate, RequiredDate: doc.RequiredDate === '0001-01-01T00:00:00' ? '' : doc.RequiredDate});
        }
      });
    });
    this.contratingService.getDocuemntsIndividualContract(this.IDindividualContract).subscribe(
      (documentsIndividualContract: getDocumentIndividualContract[]) => {
      this.documentsExamFormParameters.forEach((documentParameter: DocumentI) => {
        const doc = documentsIndividualContract.find(documentoId => documentoId.IdDocument === documentParameter.Id);
        if (doc !== undefined) {
          this.docsUploadIniadoExam.push({IdDocument: documentParameter.Id, IndividualContractId: this.IDindividualContract,
            urlDoc: doc.File, Id: doc.Id, IsByDate: doc.Document.IsByDate, DocumentContents: doc.Document.DocumentContents,
            RequiredDate: doc.RequiredDate === '0001-01-01T00:00:00' ? '' : doc.RequiredDate});
        }
        const docExamenMedico = documentsIndividualContract.find(docIndi => docIndi.Document.DocumentContents === 'SOLICITUD_DE_EXAMENES_MEDICOS');
        if (docExamenMedico !== undefined) {
          this.formExamType.get('examType').setValue(docExamenMedico.MedicalExamTypeId !== null &&
          docExamenMedico.MedicalExamTypeId !== 0 ? docExamenMedico.MedicalExamTypeId = docExamenMedico.MedicalExamTypeId : '');
        }
      });
    });
    this.employerService.getAddCCFemployerId(this.individualContract.personalemployerinfo.Employer.Id).subscribe((CCFemployer: any[]) => {
      this.CajadeCompensacion = CCFemployer;
    });
    this.commonService.getTypeSecurityReferences(4).subscribe(rest => {
      this.ips = rest;
    });
    this.contratingService.getBanks().subscribe((rest: any) => {
      this.bancks = rest;
    });
    this.commonService.getCommonOptions('MedicalExamType').subscribe(rest => {
      this.medicalExamType = rest;
    });
    this.commonService.getCommonOptions('BankAccountType').subscribe(rest => {
      this.bankAccountType = rest;
    });
    this.commonService.getCommonOptions('OccupationalRisk').subscribe(rest => {
      this.occupationalRisk = rest;
    });
    this.contratingService.getContributorType().subscribe((rest: any) => {
      this.contributorType = rest;
    });
  }

  dataFormIndividualContract(individualContract: IndividualContractId) {
    this.formDatosContrato.get('IndividualContractTypeId').setValue(
      individualContract.IndividualContractTypeId === 0 ? 77 : individualContract.IndividualContractTypeId);
    this.formDatosContrato.get('PersonalEmployerInfoId').setValue(individualContract.PersonalEmployerInfoId);
    this.formDatosContrato.get('PositionId').setValue(individualContract.PositionId === 0 ? '' : individualContract.PositionId);
    this.formDatosContrato.get('Salary').setValue(individualContract.Salary === 0 ? 0 : individualContract.Salary);
    this.formDatosContrato.get('StartDate').setValue(
      individualContract.StartDate === '0001-01-01T00:00:00' ? '' : individualContract.StartDate);
    this.formDatosContrato.get('ProjectId').setValue(
      individualContract.ProjectId === '00000000-0000-0000-0000-000000000000' ? '' : individualContract.ProjectId);
    this.formDatosContrato.get('PayPeriodId').setValue(individualContract.PayPeriodId === 0 ? 69 : individualContract.PayPeriodId);
    this.formDatosContrato.get('ContractId').setValue(individualContract.ContractId);
    this.formDatosContrato.get('ContractCityId').setValue(individualContract.ContractCityId === 0 ? '' : individualContract.ContractCityId);
    this.formContractNumber.get('ContractNumber').setValue(individualContract.ContractNumber);
  }

  dataFormPerson(individualContract: IndividualContractId, person: PersonalModel) {
    // Person
    this.formPersonal.get('Name').setValue(person.Name);
    this.formPersonal.get('LastName').setValue(person.LastName);
    this.formPersonal.get('Nationality').setValue( person.Nationality.toString());
    this.formPersonal.get('DocumentType').setValue(person.DocumentType);
    this.formPersonal.get('DocumentNumber').setValue(person.DocumentNumber);
    person.DocumentRaw === null || person.DocumentRaw === 'null' ? this.isCreateAppPersonal = false : this.isCreateAppPersonal = true;
    this.validateListF(person.DocumentType, person.DocumentNumber, person.CompanyInfoId === undefined ? '' : person.CompanyInfoId);
    this.formPersonal.get('CityOfBirthCode').setValue(person.CityOfBirthCode !== null ? person.CityOfBirthCode : '');
    if (person.CityOfBirthCode !== null) {this.getCitiesNacimiento(person.CityOfBirthCode.substring(0, 1)); }
    this.formPersonal.get('contryNalcionality').setValue(person.CityOfBirthCode !== null ? person.CityOfBirthCode.substring(0, 1) : '');
    this.formPersonal.get('RH').setValue(person.RH);
    this.formPersonal.get('Sex').setValue(person.Sex);
    this.formPersonal.get('BirthDate').setValue(this.fechasService.formatBirthDate(person.BirthDate));
    // PersonalEmployerInfo
    this.formPersonal.get('CityCode').setValue(individualContract.personalemployerinfo.CityCode);
    this.getTown(individualContract.personalemployerinfo.CityCode);
    this.formPersonal.get('Address').setValue(individualContract.personalemployerinfo.Address);
    this.formPersonal.get('PhoneNumber').setValue(individualContract.personalemployerinfo.PhoneNumber);
    this.formPersonal.get('EmergencyContact').setValue(individualContract.personalemployerinfo.EmergencyContact);
    this.formPersonal.get('EmergencyPhone').setValue(individualContract.personalemployerinfo.EmergencyPhone);
    this.formPersonal.get('Photo').setValue(individualContract.personalemployerinfo.Photo);
    this.formPersonal.get('Email').setValue(individualContract.personalemployerinfo.Email);
    this.formPersonal.get('TownCode').setValue(parseInt(individualContract.personalemployerinfo.TownCode, 10));
    this.formCetificados.get('EpsId').setValue(individualContract.personalemployerinfo.EpsId);
    this.formCetificados.get('AfpId').setValue(individualContract.personalemployerinfo.AfpId);
    // Fomr OTROS DATOS PERSONAL EMPLOYER INFO
    this.formOtrosDatos.get('BankId').setValue(individualContract.personalemployerinfo.BankId === undefined ||
    individualContract.personalemployerinfo.BankId === 0 ? '' : individualContract.personalemployerinfo.BankId);
    this.formOtrosDatos.get('BankAccount').setValue(individualContract.personalemployerinfo.BankAccount === null ?
      '' : individualContract.personalemployerinfo.BankAccount);
    this.formOtrosDatos.get('BankAccountTypeId').setValue(individualContract.personalemployerinfo.BankAccountTypeId === undefined ||
    individualContract.personalemployerinfo.BankAccountTypeId === 0 ? '' : individualContract.personalemployerinfo.BankAccountTypeId);
    this.formOtrosDatos.get('CcfId').setValue(individualContract.personalemployerinfo.CcfId === undefined ||
    individualContract.personalemployerinfo.CcfId === 0 ? '' : individualContract.personalemployerinfo.CcfId);
    this.formOtrosDatos.get('ContributorTypeId').setValue(individualContract.personalemployerinfo.ContributorTypeId === undefined ||
    individualContract.personalemployerinfo.ContributorTypeId === 0 ? '' : individualContract.personalemployerinfo.ContributorTypeId);
    this.formOtrosDatos.get('TypeARLId').setValue(individualContract.personalemployerinfo.TypeARLId === undefined ||
    individualContract.personalemployerinfo.TypeARLId === 0 ? '' : individualContract.personalemployerinfo.TypeARLId);
    this.getSelectedContracting(individualContract.personalemployerinfo.Employer.Id);
    this.servicesPersonal();
  }

  validateListF(documentType, documentNumber, CompanyInfoId) {
    this.contratingService.getPersonalBlackList(documentType, documentNumber, CompanyInfoId).subscribe(rest => {
      rest === true ? this.flagListF = false : this.flagListF = true;
    });
  }

  postPersonalBlackList() {
    this.dialogService.openDialogConfirm('Esta seguro de agregarlo a la lista').afterClosed().subscribe(rest => {
      if (rest !== false) {
        const personalBlack: PersonalBlackList =
        { DocumentType: this.formPersonal.get('DocumentType').value,
          DocumentNumber: this.formPersonal.get('DocumentNumber').value,
          StartDate: new Date(),
        };
        this.contratingService.postPersonalBlackListSanction(personalBlack).subscribe(() => {
          this.flagListF = false;
        });
      }
    });
  }

  deletePersonalBlackList(): void {
    this.contratingService.getAllPersonalBlackList().subscribe((personalBlack: GetPersonalBlackList[]) => {
      const person = personalBlack.find(personBlack => personBlack.DocumentNumber === this.personal.DocumentNumber);

      if (person !== undefined) {
        this.dialogService.openDialogConfirm('Esta seguro de quitarlo de la lista?').afterClosed().subscribe(rest => {
          if (rest !== false) {
            this.contratingService.deletePersonalBlackList(person.Id).subscribe(() => {
              this.snackBService.openWarning('Se a quitado de la lista.', '', 4000);
              this.flagListF = true;
            });
          }
        });
      }
    });
  }

  servicesPersonal() {
    this.commonService.getCommonOptions('Nationality').subscribe((data: CommonOptions[]) => {
      this.nationality = data;
    });
    this.commonService.getCommonOptions('Country').subscribe((data: CommonOptions[]) => {
      this.countrys = data;
    });
    this.commonService.getCommonOptions('RH').subscribe((data: CommonOptions[]) => {
      this.rh = data.sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
    });
    this.commonService.getCommonOptions('CompanyDocumentType').subscribe((data: CommonOptions[]) => {
      this.companyDocumentType = data.filter(documents => documents.Value === 'CC' || documents.Value === 'CE' || documents.Value === 'PE')
          .sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
    });
    this.commonService.getCommonOptions('Sex').subscribe((data: CommonOptions[]) => {
      this.sex = data.sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
    });
    this.commonService.getCommonOptions('MedicalExamType').subscribe((data: CommonOptions[]) => {
      this.examType = data.sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
    });
    this.commonService.getCommonOptions('IndividualContractsStageType').subscribe(rest => {
      this.states = rest;
    });
    this.commonService.getCommonOptions('IndividualContractsType').subscribe(rest => {
      this.individualContractsType = rest;
    });
    this.commonService.getCommonOptions('PayPeriodType').subscribe(rest => {
      this.payPeriodType = rest;
    });
    this.employerService.getPositionEmployerId(this.individualContract.personalemployerinfo.Employer.Id).subscribe(
      (positions: Positions[]) => {
      this.positions = positions;
    });
    this.getdocumentsForNationalyty(this.formPersonal.get('Nationality').value);
    this.commonService.getSecurityReferences().subscribe(data => {
      this.securityReferences = data;
      this.eps = this.securityReferences.filter(x => x.Type === TypeSecurityReference.EPS).sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
      this.afp = this.securityReferences.filter(x => x.Type === TypeSecurityReference.AFP).sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
  });
    this.getDaneCity();

  }

  getdocumentsForNationalyty(nationalidad: string): void {
    this.contratingService.getDocument().subscribe((documents: DocumentI[]) => {
      if (nationalidad === '0') {
        this.documentsAndRquisitosParameters = documents.filter(doc =>
            doc.IsUpload === true && doc.DocumentContents === 'DocumentsForm' && doc.Abrv !== 'PPE' && doc.Abrv !== 'PEP')
          .sort((a, b) => parseInt(a.OrderNum, 10) > parseInt(b.OrderNum, 10) ? 1 : -1);
      } else {
        this.documentsAndRquisitosParameters = documents.filter(doc => doc.IsUpload === true && doc.DocumentContents === 'DocumentsForm')
          .sort((a, b) => parseInt(a.OrderNum, 10) > parseInt(b.OrderNum, 10) ? 1 : -1);
      }

      this.documentsExamFormParameters = documents.filter(doc => doc.IsUpload === true && doc.DocumentContents === 'ExamForm');
      this.documentsGenerateParameters = documents.filter(doc => doc.IsUpload === false);
    });
  }

  selectionChangeGetdocumentsForNationalyty(event) {
    this.getdocumentsForNationalyty(event);
  }

  selectedDaneCityTown(e: any) {
    this.getTown(e);
  }

  getStateId(textState: string): number {
    let stateIniciat = 0;
    this.states.forEach(state => {
      state.Description === textState ? stateIniciat = state.Id : stateIniciat =  stateIniciat;
    });
    return stateIniciat;
  }

  getSelectedContracting(CompanyId) {
    this.contratingService.getListSelectContracting(CompanyId).subscribe((rest: any) => {
      this.proyectSelect = [];
      this.proyectSelect = rest;
    });
  }

  getDaneCity() {
    this.commonService.getDaneCity().subscribe((daneCity: DaneCity[]) => {
      this.daneCity = daneCity;
    });
  }

  getCitiesNacimiento(numberContry: NumberCountry){
    this.commonService.getCities(numberContry).subscribe((data: City[]) => {
      this.citiesNacimiento = data;
    });
  }

  getTown(CodeCity) {
    this.contratingService.getTownIdCity(CodeCity).subscribe((data: any) => {
      this.town = data;
    });
  }

  openDialogPhotoPersonal() {
    this.dialogService.openDialogGestorImg('CARGAR IMAGEN', [], 'editPhoto', 0, 'true', true).afterClosed().subscribe(formDataPhoto => {
      if (formDataPhoto !== undefined) {
        this.contratingService.updatePhotoPersonal(this.individualContract.personalemployerinfo.Id,
          formDataPhoto.FormData).subscribe(rest => {
          this.getContracting(this.IDindividualContract);
          this.snackBService.openWarning('Foto Actualizada', 'X', 4000);
        });
      }
    });
  }

  uploadDoc(docId, inputDate?) {
    if (this.exitPermission('contractingdocuments.upload')) {
      this.dialogService.openDialogGestorImg('GESTOR DE DOCUMENTOS', [], 'editPhoto', 0, 'true').afterClosed().subscribe((rest: any) => {
        rest !== undefined ? this.setArrayDocumentSave(rest, docId, inputDate) : this.formDataPhoto = this.formDataPhoto;
      });
    } else {
      this.snackBService.openWarning('No tienes permiso de subir archivos', '', 4000);
    }
  }

  uploadDocExam(docId, inputDate?) {
    if (this.exitPermission('contractingmedicalcert.upload')) {
      this.dialogService.openDialogGestorImg('GESTOR DE DOCUMENTOS', [], 'editPhoto', 0, 'true').afterClosed().subscribe((rest: any) => {
        rest !== undefined ? this.setArrayDocumentExamSave(rest, docId, inputDate) : this.formDataPhoto = this.formDataPhoto;
      });
    } else {
      this.snackBService.openWarning('No tienes permiso de subir archivos', '', 4000);
    }
  }

  changeSelectedDate(IdDocument, Fecha): void {
    const date = this.fechasService.getDateFormatDatePiker(this.fechasService.formatDateYYYYMMDD(Fecha));

    for (const docUpload of this.docsUploadIniado) {
      if (IdDocument === docUpload.IdDocument) {
        docUpload.RequiredDate = date;
        this.setDateRequiredDate(docUpload);
      }
    }
  }

  changeSelectedDateExam(IdDocument, Fecha): void {
    const date = this.fechasService.getDateFormatDatePiker(this.fechasService.formatDateYYYYMMDD(Fecha));

    for (const docUploadExam of this.docsUploadIniadoExam) {
      if (IdDocument === docUploadExam.IdDocument) {
        docUploadExam.RequiredDate = date;
        this.setDateRequiredDateExam(docUploadExam);
      }
    }
  }


  noExitRequiredDate(): boolean {
    let exit = false;

    for (const docUpload of this.docsUploadIniado) {
      if (docUpload.IsByDate === true && (docUpload.RequiredDate === '' || docUpload.RequiredDate === '0001-01-01T00:00:00' ||
        docUpload.RequiredDate === null)) {
        exit = true;
      }
    }
    return exit;
  }

  noExitRequiredDateExam(): boolean {
    let exit = false;

    for (const docUploadExam of this.docsUploadIniadoExam) {
      if (docUploadExam.DocumentContents === 'ExamForm' && docUploadExam.IsByDate === true && (
          docUploadExam.RequiredDate === '' || docUploadExam.RequiredDate === '0001-01-01T00:00:00' ||
          docUploadExam.RequiredDate === null)) {
        exit = true;
      }
    }
    return exit;
  }

  setDateRequiredDate(dateRequiredDate: DocumentIndividualPost): void {
    if (this.dateRequiredDate.length === 0) {
      this.dateRequiredDate.push(dateRequiredDate);
    } else {
      for (const currentDateRequired of this.dateRequiredDate) {
        if (currentDateRequired.IdDocument === dateRequiredDate.IdDocument) {
          currentDateRequired.RequiredDate = dateRequiredDate.RequiredDate;
        } else {
          this.dateRequiredDate.push(dateRequiredDate);
        }
      }
    }
  }

  setDateRequiredDateExam(dateRequiredDateExam: DocumentIndividualPost): void {
    if (this.dateRequiredDateExam.length === 0) {
      this.dateRequiredDateExam.push(dateRequiredDateExam);
    } else {
      for (const currentDateRequiredExam of this.dateRequiredDateExam) {
        if (currentDateRequiredExam.IdDocument === dateRequiredDateExam.IdDocument) {
          currentDateRequiredExam.RequiredDate = dateRequiredDateExam.RequiredDate;
        } else {
          this.dateRequiredDateExam.push(dateRequiredDateExam);
        }
      }
    }
  }

  getDateRequired(Id): string {
    for (const docUpload of this.docsUploadIniado) {
      if (Id === docUpload.IdDocument) {
        return docUpload.RequiredDate;
      }
    }
  }

  getDateRequiredExam(Id): string {
    for (const docUploadExam of this.docsUploadIniadoExam) {
      if (Id === docUploadExam.IdDocument) {
        return docUploadExam.RequiredDate;
      }
    }
  }

  putDocumentRequiredDateIndividual() {
    if (this.dateRequiredDate.length > 0){
      this.dateRequiredDate.forEach(data => {
        const docData = {
          IndividualContractId: this.IDindividualContract,
          IdDocument: data.IdDocument,
          RequiredDate: data.RequiredDate
        };
        this.contratingService.postDocumentDataIndividual(docData).subscribe(rest => {});
      });
    }
  }

  putDocumentRequiredDateIndividualExam() {
    if (this.dateRequiredDateExam.length > 0){
      this.dateRequiredDateExam.forEach(data => {
        const docData = {
          IndividualContractId: this.IDindividualContract,
          IdDocument: data.IdDocument,
          RequiredDate: data.RequiredDate
        };
        this.contratingService.postDocumentDataIndividual(docData).subscribe(rest => {});
      });
    }
  }

  setArrayDocumentExamSave(formData: FormData, docId, inputDate){
    let date = this.fechasService.formatDateYYYYMMDD(inputDate);
    date === null || date === undefined ? date = '' : date = date;
    if (this.docsUploadExam.length  === 0) {
      date === '' ?
      this.docsUploadExam.push({
        IndividualContractId: this.individualContract.Id,
        IdDocument: docId,
        FileData: formData,
      }) :
      this.docsUploadExam.push({
        IndividualContractId: this.individualContract.Id,
        IdDocument: docId,
        FileData: formData,
        RequiredDate: date
      });
    } else {
      this.docsUploadExam.forEach(docFile => {
        if (docFile.IdDocument === docId) {
          docFile.FileData = formData;
        } else {
          const exit = this.docsUploadExam.find(doc => doc.IdDocument === docId);
          exit === undefined ?
          (
          date === '' ?
          this.docsUploadExam.push({
            IndividualContractId: this.individualContract.Id,
            IdDocument: docId,
            FileData: formData,
          }) :
          this.docsUploadExam.push({
            IndividualContractId: this.individualContract.Id,
            IdDocument: docId,
            FileData: formData,
            RequiredDate: date
          })
          )
          :
          this.docsUploadExam = this.docsUploadExam;
        }
      });
    }
    this.docsUploadExam.forEach(doc => {
      if (docId === doc.IdDocument) {
        this.contratingService.postDocumentDataIndividual(doc).subscribe((rest: any) => {
          this.contratingService.putDocumentFileIndividual(rest.IdDocument, doc.FileData).subscribe(() => {
            this.documentsExamFormParameters.forEach((documentParameter: DocumentI) => {
              if (docId === documentParameter.Id) {
                this.contratingService.getDocuemntsIndividualContract(this.IDindividualContract).subscribe(
                  (documentsIndividualContract: getDocumentIndividualContract[]) => {
                    const documentIndividualContract = documentsIndividualContract.find(
                      documentoId => documentoId.IdDocument === documentParameter.Id
                    );

                    if (documentIndividualContract !== undefined) {
                      const documento = this.docsUploadIniadoExam.find(
                        docUpload => docId === docUpload.IdDocument
                      );

                      if (documento === undefined) {
                        this.docsUploadIniadoExam.push({
                          IdDocument: documentParameter.Id,
                          IndividualContractId: this.IDindividualContract,
                          urlDoc: documentIndividualContract.File,
                          Id: documentIndividualContract.Id,
                          RequiredDate: documentIndividualContract.RequiredDate === '0001-01-01T00:00:00'
                            ? ''
                            : documentIndividualContract.RequiredDate,
                          DocumentContents: documentIndividualContract.Document.DocumentContents,
                          IsByDate: documentIndividualContract.Document.IsByDate
                        });
                      } else {
                        this.docsUploadIniadoExam.forEach((value, index) => {
                          if (value.IdDocument === docId) {
                            this.docsUploadIniadoExam[index].urlDoc = documentIndividualContract.File;
                          }
                        });
                      }
                    }
                  }
                );
              }
            });
          });
        });
      }
    });
  }

  setArrayDocumentSave(formData: FormData, docId, inputDate){
    let date = this.fechasService.formatDateYYYYMMDD(inputDate);
    date === null || date === undefined ? date = '' : date = date;
    if (this.docsUpload.length  === 0) {
      date === '' ?
      this.docsUpload.push({
        IndividualContractId: this.individualContract.Id,
        IdDocument: docId,
        FileData: formData,
      }) :
      this.docsUpload.push({
        IndividualContractId: this.individualContract.Id,
        IdDocument: docId,
        FileData: formData,
        RequiredDate: date
      });
    } else {
      this.docsUpload.forEach(docFile => {
        if (docFile.IdDocument === docId) {
          docFile.FileData = formData;
        } else {
          const exit = this.docsUpload.find(doc => doc.IdDocument === docId);
          exit === undefined ?
          (
          date === '' ?
          this.docsUpload.push({
            IndividualContractId: this.individualContract.Id,
            IdDocument: docId,
            FileData: formData,
          }) :
          this.docsUpload.push({
            IndividualContractId: this.individualContract.Id,
            IdDocument: docId,
            FileData: formData,
            RequiredDate: date
          })
          )
          :
          this.docsUpload = this.docsUpload;
        }
      });
    }
    this.docsUpload.forEach(doc => {
      if (docId === doc.IdDocument) {
        this.contratingService.postDocumentDataIndividual(doc).subscribe((rest: any) => {
          this.contratingService.putDocumentFileIndividual(rest.IdDocument, doc.FileData).subscribe(() => {
            this.documentsAndRquisitosParameters.forEach((documentParameter: DocumentI) => {
              if (docId === documentParameter.Id) {
                this.contratingService.getDocuemntsIndividualContract(this.IDindividualContract).subscribe(
                  (documentsIndividualContract: getDocumentIndividualContract[]) => {
                    const documentIndividualContract = documentsIndividualContract.find(
                      documentoId => documentoId.IdDocument === documentParameter.Id);

                    if (documentIndividualContract !== undefined) {
                      const documento = this.docsUploadIniado.find(docUpload => docId === docUpload.IdDocument);

                      if (documento === undefined) {
                        this.docsUploadIniado.push({
                          IdDocument: documentParameter.Id,
                          IndividualContractId: this.IDindividualContract,
                          urlDoc: documentIndividualContract.File,
                          Id: documentIndividualContract.Id,
                          RequiredDate: documentIndividualContract.RequiredDate === '0001-01-01T00:00:00'
                            ? '' : documentIndividualContract.RequiredDate, IsByDate: documentIndividualContract.Document.IsByDate
                        });
                      } else {
                        this.docsUploadIniado.forEach((value, index) => {
                          if (value.IdDocument === docId) {
                            this.docsUploadIniado[index].urlDoc = documentIndividualContract.File;
                          }
                        });
                      }
                    }
                  }
                );
              }
            });
          });
        });
      }
    });
  }

  exitDocumentUpload(IdDocument): boolean {
    let exit = false;
    if (this.docsUpload.length !== 0 || this.docsUploadIniado.length !== 0) {
      this.docsUpload.find(doc => doc.IdDocument === IdDocument) !== undefined ?
      exit = true :
      this.docsUploadIniado.find(doc => doc.IdDocument === IdDocument) !== undefined ? exit = true : exit = false;
    }
    return exit;
  }

  exitDocumentUploadExamForm(IdDocument): boolean {
    let exit = false;
    if (this.docsUploadExam.length !== 0 || this.docsUploadIniadoExam.length !== 0) {
      this.docsUploadExam.find(doc => doc.IdDocument === IdDocument) !== undefined ?
      exit = true :
      this.docsUploadIniadoExam.find(doc => doc.IdDocument === IdDocument) !== undefined ? exit = true : exit = false;
    }
    return exit;
  }


  getImg(logo): string {
    const img = (logo === null || logo === '' ? 'upload/images/form-images/file_235c080f-43b7-42c6-bd43-0af779cdb223.svg' : logo);
    return img;
  }

  deleteOrden() {
    this.dialogService.openDialogConfirm('Esta seguro de eliminar el contrato individual?').afterClosed().subscribe(restClose => {
        if (restClose !== false) {
          this.contratingService.deleteIndividualContract(this.IDindividualContract).subscribe(deleteRest => {
            this.router.navigate(['/admin/contracting']);
          });
        }
    });
  }

  onSubmit() {
    if (this.state !== 'APROBADO') {
      this.formDatosContrato.get('PersonalEmployerInfoId').setValue(this.individualContract.PersonalEmployerInfoId);
      this.formDatosContrato.get('ContractId').setValue(this.individualContract.ContractId);
      if (this.state === 'INICIADO' || this.state === 'RECHAZADO') {
        if (this.docsUpload.length !== this.documentsAndRquisitosParameters.length && this.docsUploadIniado.length === 0) {
          this.snackBService.openWarning('FALTA DOCUMENTOS O REQUISITOS DEL EMPLEADO1', '', 4000);
        } else if (this.documentsAndRquisitosParameters.length > this.docsUploadIniado.length){
          this.snackBService.openWarning('FALTA DOCUMENTOS O REQUISITOS DEL EMPLEADO2', '', 4000);
        } else if (this.formCetificados.status !== 'VALID' || this.formCetificados.get('EpsId').value === 0 || this.formCetificados.get('AfpId').value === 0){
          this.snackBService.openWarning('FALTA SELECCIONAR LA EPS O AFP DE LOS DOCUMENTOS', '', 4000);
        } else if (this.noExitRequiredDate()) {
          this.snackBService.openWarning('FALTAN FECHAS DE DOCUMENTO', '', 4000);
        } else if (this.formDatosContrato.status !== 'VALID') {
          this.snackBService.openWarning('FALTA DATOS DEL CONTRATO', '', 4000);
        } else {
          this.postStateInicial(this.state);
        }
      } else if (this.state === 'SOLICITADO') {
        if (this.docsUpload.length !== this.documentsAndRquisitosParameters.length && this.docsUploadIniado.length === 0) {
          this.snackBService.openWarning('FALTA DOCUMENTOS O REQUISITOS DEL EMPLEADO', '', 4000);
        } else if (this.documentsAndRquisitosParameters.length > this.docsUploadIniado.length){
          this.snackBService.openWarning('FALTA DOCUMENTOS O REQUISITOS DEL EMPLEADO', '', 4000);
        } else if (this.noExitRequiredDate()) {
          this.snackBService.openWarning('FALTAN FECHAS DE DOCUMENTO', '', 4000);
        } else if (this.formDatosContrato.status !== 'VALID') {
          this.snackBService.openWarning('FALTA DATOS DEL CONTRATO', '', 4000);
        } else {
          this.postStateSolicitado('SOLICITADO');
        }
      }
    } else {
      if (this.formOtrosDatos.status === 'INVALID') {
        this.snackBService.openWarning('Faltan datos bancarios', '', 4000);
      } else if (!this.exitTypeDocument('SOLICITUD_DE_EXAMENES_MEDICOS')) {
        this.snackBService.openWarning('Falta examen de ingreso', '', 4000);
      } else if (this.docsUploadExam.length !== this.documentsExamFormParameters.length && this.docsUploadIniadoExam.length === 0) {
        this.snackBService.openWarning('FALTA CERTIFICADOS DE EXAMENES MEDICOS', '', 4000);
      } else if (this.documentsExamFormParameters.length > this.docsUploadIniadoExam.length){
        this.snackBService.openWarning('FALTA CERTIFICADOS DE EXAMENES MEDICOS', '', 4000);
      } else if (this.noExitRequiredDateExam()) {
        this.snackBService.openWarning('FALTAN FECHAS DE CERTIFICADOS', '', 4000);
      } else {
          this.contratingService.postGenerateProjectContract(this.IDindividualContract).subscribe(rest => {
            this.contratingService.postGenerateDocumentMedicalAdviceAcknowledgement(this.IDindividualContract).subscribe(() => {
              this.contratingService.postGenerateDocumentDataAuthorization(this.IDindividualContract).subscribe(() => {
                this.contratingService.postGenerateDocumentAuthMedicalExam(this.IDindividualContract).subscribe(() => {
                  this.snackBService.openSuccess('ARCHIVOS GENERADOS', '', 4000);
                  this.postStateAprovado('CONTRATADO');
                });
              });
            });
          });
      }
    }
    if (this.state === 'CONTRATADO') {
      this.putDocumentRequiredDateIndividualExam();
      this.savePersonalEmployerInfo();
      this.upDatePersonal();
    }
  }

  postStateInicial(state: string) {
    this.individualContractPut = {
      IndividualContractTypeId: this.formDatosContrato.get('IndividualContractTypeId').value,
      PersonalEmployerInfoId: this.formDatosContrato.get('PersonalEmployerInfoId').value,
      ContractNumber: this.formContractNumber.get('ContractNumber').value,
      PositionId: this.formDatosContrato.get('PositionId').value,
      Salary: this.formDatosContrato.get('Salary').value.toString().replace(/\$/g, '').replace(/\./g, ''),
      PayPeriodId: this.formDatosContrato.get('PayPeriodId').value,
      StartDate: this.formDatosContrato.get('StartDate').value,
      ProjectId: this.formDatosContrato.get('ProjectId').value,
      ContractId: this.formDatosContrato.get('ContractId').value,
      ContractCityId: this.formDatosContrato.get('ContractCityId').value,
      IndividualContractStage:
        { Comment: '', StageTypeId: this.getStateId(state), IndividualContractId: this.IDindividualContract },
    };
    this.savePersonalEmployerInfo();
    this.upDatePersonal();
    this.putDocumentRequiredDateIndividual();
    this.contratingService.putIndividualContract(this.IDindividualContract, this.individualContractPut).subscribe(() => {
        this.contratingService.postGenerateDocumentDatosContrato(this.IDindividualContract).subscribe((documentResponse: any) => {
            if (state === 'INICIADO' || state === 'RECHAZADO') {
              this.dialogService.openDialogIndividualContractAproved('CONFIRMAR SOLICITUD', undefined, 'Orden de contratación',
                  this.getUrlDocument(documentResponse.url), 'CONFIRMAR SOLICITUD').afterClosed().subscribe(dialogResponse => {
                  if (dialogResponse !== undefined) {
                    this.docsUpload = [];
                    this.postStateInicial('SOLICITADO');
                  }
                });
            } else if (state === 'SOLICITADO') {
              this.getContracting(this.IDindividualContract);
            }
          });
      });
  }

  postStateSolicitado(state: string) {
    this.individualContractPut = {
      IndividualContractTypeId: this.formDatosContrato.get('IndividualContractTypeId').value,
      PersonalEmployerInfoId: this.formDatosContrato.get('PersonalEmployerInfoId').value,
      ContractNumber: this.formContractNumber.get('ContractNumber').value,
      PositionId: this.formDatosContrato.get('PositionId').value,
      Salary: this.formDatosContrato.get('Salary').value.toString().replace(/\$/g, '').replace(/\./g, ''),
      PayPeriodId: this.formDatosContrato.get('PayPeriodId').value,
      StartDate: this.formDatosContrato.get('StartDate').value,
      ProjectId: this.formDatosContrato.get('ProjectId').value,
      ContractId: this.formDatosContrato.get('ContractId').value,
      ContractCityId: this.formDatosContrato.get('ContractCityId').value,
      IndividualContractStage:
        { Comment: '', StageTypeId: this.getStateId(state), IndividualContractId: this.IDindividualContract },
    };
    this.savePersonalEmployerInfo();
    this.upDatePersonal();
    this.putDocumentRequiredDateIndividual();
    this.contratingService.putIndividualContract(this.IDindividualContract, this.individualContractPut).subscribe(() => {
      this.contratingService.postGenerateDocumentDatosContratoAproved(this.IDindividualContract).subscribe((documentResponse: any) => {
        if (state === 'SOLICITADO') {
          this.dialogService.openDialogIndividualContractAproved('APROBAR SOLICITUD', undefined, 'Orden de contratación',
            this.getUrlDocument(documentResponse.url), 'APROBAR SOLICITUD').afterClosed().subscribe(dialogResponse => {
            if (dialogResponse !== undefined) {
              this.contratingService.postGenerateDocumentDatosContratoAproved(this.IDindividualContract).subscribe(
                (approvedResponse: any) => {
                this.docsUpload = [];
                if (approvedResponse !== undefined) {
                  this.postStateSolicitado('APROBADO');
                }
              });
            }
          });
        } else if (state === 'APROBADO') {
          this.getContracting(this.IDindividualContract);
        }
      });
    });
  }

  postStateAprovado(state: string) {
    this.individualContractPut = {
      IndividualContractTypeId: this.formDatosContrato.get('IndividualContractTypeId').value,
      PersonalEmployerInfoId: this.formDatosContrato.get('PersonalEmployerInfoId').value,
      ContractNumber: this.formContractNumber.get('ContractNumber').value,
      PositionId: this.formDatosContrato.get('PositionId').value,
      Salary: this.formDatosContrato.get('Salary').value.toString().replace(/\$/g, '').replace(/\./g, ''),
      PayPeriodId: this.formDatosContrato.get('PayPeriodId').value,
      StartDate: this.formDatosContrato.get('StartDate').value,
      ProjectId: this.formDatosContrato.get('ProjectId').value,
      ContractId: this.formDatosContrato.get('ContractId').value,
      ContractCityId: this.formDatosContrato.get('ContractCityId').value,
      IndividualContractStage:
        { Comment: '', StageTypeId: this.getStateId(state), IndividualContractId: this.IDindividualContract },
    };
    this.savePersonalEmployerInfo();
    this.upDatePersonal();
    this.putDocumentRequiredDateIndividual();
    this.putDocumentRequiredDateIndividualExam();
    this.contratingService.putIndividualContract(this.IDindividualContract, this.individualContractPut).subscribe(() => {
        if (state === 'APROBADO'){
            this.contratingService.postGenerateDocumentDatosContratoAproved(this.IDindividualContract).subscribe(() => {
              this.postStateAprovado('CONTRATADO');
            });
        } else if (state === 'CONTRATADO') {
          this.getContracting(this.IDindividualContract);
        }
      });
  }

  openDialogIndividualContractRechazar(): void {
    this.contratingService.postGenerateDocumentIndividualContractRechazada(
      this.IDindividualContract).subscribe((contratoRechazado: any) => {
        this.dialogService.openDialogIndividualContractAproved('RECHAZAR ORDEN', undefined, 'Orden de contratación',
            this.getUrlDocument(contratoRechazado.url), 'RECHAZAR SOLICITUD', true).afterClosed().subscribe(dialogResponse => {
            if (dialogResponse !== undefined || dialogResponse === '') {
              this.rechazarOrden(dialogResponse);
            }
          });
      });
  }

  anularOrdern() {
    this.dialogService.openDialogIndividualContractAproved('ANULAR APROBACIÓN', undefined, 'Orden de contratación',
      '', 'ANULAR APROBACIÓN', true).afterClosed().subscribe(comment => {
      if (comment !== undefined || comment === '') {
        this.contratingService.postGenerateDocumentIndividualContractRechazada(this.IDindividualContract).subscribe(rest => {
          const model = { Comment: comment, StageTypeId: this.getStateId('ANULADO'), IndividualContractId: this.IDindividualContract };
          this.contratingService.changeStateIndividualContract(model).subscribe(() => {
            this.docsUpload = [];
            this.getContracting(this.IDindividualContract);
          });
        });
      }
    });
  }

  rechazarOrden(Comment) {
    this.contratingService.postGenerateDocumentIndividualContractRechazada(this.IDindividualContract).subscribe(rest => {
      const model = { Comment, StageTypeId: this.getStateId('RECHAZADO'), IndividualContractId: this.IDindividualContract };
      this.contratingService.changeStateIndividualContract(model).subscribe(() => {
        this.docsUpload = [];
        this.getContracting(this.IDindividualContract);
      });
    });
  }

  savePersonalEmployerInfo() {
    const personalEmployerInfo: PersonalEmployerInfo = {
      CityCode: this.formPersonal.get('CityCode').value,
      TownCode: this.formPersonal.get('TownCode').value,
      Address: this.formPersonal.get('Address').value,
      PhoneNumber: this.formPersonal.get('PhoneNumber').value,
      EmergencyContact: this.formPersonal.get('EmergencyContact').value,
      EmergencyPhone: this.formPersonal.get('EmergencyPhone').value,
      EpsId: this.formCetificados.get('EpsId').value,
      AfpId: this.formCetificados.get('AfpId').value,
      Email: this.formPersonal.get('Email').value,
      BankAccount: this.formOtrosDatos.get('BankAccount').value === '' ? '' : this.formOtrosDatos.get('BankAccount').value,
      CcfId: this.formOtrosDatos.get('CcfId').value === '' ? 0 : this.formOtrosDatos.get('CcfId').value,
      BankId: this.formOtrosDatos.get('BankId').value === '' ? 0 : this.formOtrosDatos.get('BankId').value,
      BankAccountTypeId: this.formOtrosDatos.get('BankAccountTypeId').value === '' ? 0 : this.formOtrosDatos.get('BankAccountTypeId').value,
      ContributorTypeId: this.formOtrosDatos.get('ContributorTypeId').value === '' ? 0 : this.formOtrosDatos.get('ContributorTypeId').value,
      TypeARLId: this.formOtrosDatos.get('TypeARLId').value === '' ? 0 : this.formOtrosDatos.get('TypeARLId').value
    };
    this.contratingService.putPersonalEmployerInfo(this.individualContract.PersonalEmployerInfoId, personalEmployerInfo).subscribe(() => {
    });
  }

  upDatePersonal() {
    if (this.isCreateAppPersonal === false) {
      let birthDate = '';
      if (typeof this.formPersonal.get('BirthDate').value === 'object') {
        birthDate = this.fechasService.getDateFormatDayMontYear(this.formPersonal.get('BirthDate').value);
      } else {
        birthDate = this.formPersonal.get('BirthDate').value.toString().replace(/\-/g, '').substr(0, 8);
      }
      const personalModel = {
        DocumentType: this.formPersonal.get('DocumentType').value,
        DocumentNumber: this.formPersonal.get('DocumentNumber').value,
        Name: this.formPersonal.get('Name').value,
        BirthDate: birthDate,
        LastName: this.formPersonal.get('LastName').value,
        RH: this.formPersonal.get('RH').value,
        Sex: this.formPersonal.get('Sex').value,
        Nationality: this.formPersonal.get('Nationality').value,
        CityOfBirthCode: this.formPersonal.get('CityOfBirthCode').value,
      };
      this.personaService.putUpdatePersonal(personalModel).subscribe(() => {
      });
    }
  }

  getUrlDocCreateInicial(IdDocument: string): boolean {
    let exit: boolean;
    this.docsUploadIniado.find(doc => doc.IdDocument === IdDocument) !== undefined ?
    exit = true : exit = false;
    return exit;
  }

  getUrlDocCreateInicialExam(IdDocument: string): boolean {
    let exit: boolean;
    this.docsUploadIniadoExam.find(doc => doc.IdDocument === IdDocument) !== undefined ?
    exit = true : exit = false;
    return exit;
  }

  openDialogImageOrVideoOrPdf(IdDocument: string): void {
    const selectedDoc = this.docsUploadIniado.find(docUpload => docUpload.IdDocument === IdDocument);

    if (selectedDoc !== undefined) {
      if (selectedDoc.urlDoc !== '' && selectedDoc.urlDoc !== undefined && selectedDoc.urlDoc !== null) {
        this.dialogService.openDialogImageOrVideoOrPdf(this.getUrlDocument(selectedDoc.urlDoc))
          .afterClosed().subscribe(() => {});
      } else {
        this.snackBService.openWarning('NO HAY DOCUMENTO GUARDADO', '', 4000);
      }
    }
  }

  openDialogImageOrVideoOrPdfExam(IdDocument: string): void {
    const selectedDocExam = this.docsUploadIniadoExam.find(docUploadExam => docUploadExam.IdDocument === IdDocument);

    if (selectedDocExam !== undefined) {
      if (selectedDocExam.urlDoc !== '' && selectedDocExam.urlDoc !== undefined && selectedDocExam.urlDoc !== null) {
        this.dialogService.openDialogImageOrVideoOrPdf(this.getUrlDocument(selectedDocExam.urlDoc))
          .afterClosed().subscribe(() => {});
      } else {
        this.snackBService.openWarning('NO HAY DOCUMENTO GUARDADO', '', 4000);
      }
    }
  }

  getUrlDocument(urlDoc: string): string {
    const url: string = urlDoc.split('.com/')[1];
    return url;
  }

  getNameDocumentGenerate(DocumentContents): string {
    let name = '';

    if (this.docsSave.length !== 0) {
      const documentGenerate = this.documentsGenerateParameters.find(
        documentParameter => documentParameter.DocumentContents === DocumentContents);

      if (documentGenerate !== undefined) {
        name = documentGenerate.Name;
      }
    }

    return name;
  }

  exitTypeDocument(tipoDocument): boolean {
    let exit = false;

    if (this.docsSave.length !== 0) {
      const savedDocument = this.docsSave.find(
        documentSaved => documentSaved.Document.DocumentContents === tipoDocument);

      if (savedDocument !== undefined) {
        exit = true;
      }
    }
    return exit;
  }

  deleteTypeDocument(typeDocument: string): void {
    this.dialogService.openDialogConfirm('Esta seguro de eliminar el documento').afterClosed().subscribe(restDialog => {
        if (restDialog !== false) {
          if (this.docsSave.length !== 0) {
            const savedDocument = this.docsSave.find(documentSaved => documentSaved.Document.DocumentContents === typeDocument);

            if (savedDocument !== undefined) {
              this.contratingService.deleteDocumentId(savedDocument.Id).subscribe(() => {
                this.getDocumentStatesAll();
              });
            }
          }
        }
      });
  }

  showTypeDocument(tipoDocument): void {
    if (this.docsSave.length !== 0) {
      const savedDocument = this.docsSave.find(documentSaved => documentSaved.Document.DocumentContents === tipoDocument);

      if (savedDocument !== undefined) {
        this.showGenerateSolicitud(savedDocument.File);
      }
    }
  }

  getGenerateExamenMedico(){
    if (this.formExamType.status === 'VALID') {
      this.contratingService.postGenerateDocumentExamenMedico(this.IDindividualContract,
        this.formExamType.get('examType').value).subscribe(() => {this.contratingService.getDocuemntsIndividualContract(
          this.IDindividualContract).subscribe((documentsIndividualContract: getDocumentIndividualContract[]) => {
          this.docsSave = documentsIndividualContract;
          this.snackBService.openSuccess('ARCHIVO GENERADO', '', 4000);
        });
      });
    } else {
      this.snackBService.openWarning('FALTA SELECCIONAR TIPO DE EXAMEN MEDICO', '', 4000);
    }
  }

  showGenerateSolicitud(docUrl) {
    const url = this.getUrlDocument(docUrl);
    this.dialogService.openDialogImageOrVideoOrPdf(url).afterClosed().subscribe(() => {
    });
  }

  exitPermission(permiso: string): boolean {
    let exit = false;
    const permisionsUserInfo  = this.permissions.find(x => x === permiso);
    permisionsUserInfo !== undefined ? exit = true : exit = false;
    return exit;
  }

}
